import TablePagination from '@mui/material/TablePagination';
import { onPageChange, onRowsOnPageChange } from '../actions/table';
import { Dispatch } from 'redux';
import { ReduxComponentInterface } from 'edocatbase/Global';
import { TablePagination as Pagination } from 'edocatbase/Table';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

export interface TablePaginationProps extends ReduxComponentInterface {
  tableName: string;
  pagination: Pagination;
  tablePageChangeHandler?: (page: number) => void;
  onRowsPerPageChangeHandler?: (pageSize: string) => void;
  rowsPerPageOptions?: number[];
}

class EdocatTablePagination extends React.PureComponent<TablePaginationProps> {
  static defaultProps = {
    rowsPerPageOptions: [],
  };

  onPageChange = (event: React.MouseEvent | null, page: number) => {
    event && event.preventDefault();
    const { actions, tableName, tablePageChangeHandler } = this.props;
    if (tablePageChangeHandler) return tablePageChangeHandler(page);
    actions.onPageChange(tableName, page);
  };

  onRowsOnPageChange = (event: React.ChangeEvent) => {
    event.preventDefault();
    const pageSize = (event.target as HTMLSelectElement).value;
    const { actions, tableName, onRowsPerPageChangeHandler } = this.props;
    if (onRowsPerPageChangeHandler) return onRowsPerPageChangeHandler(pageSize);
    actions.onRowsOnPageChange(tableName, pageSize);
  };

  render() {
    const { pagination, rowsPerPageOptions } = this.props;

    return (
      <TablePagination
        component="div"
        count={pagination.total}
        rowsPerPage={pagination.pageSize}
        rowsPerPageOptions={rowsPerPageOptions}
        page={pagination.current}
        onPageChange={this.onPageChange}
        onRowsPerPageChange={this.onRowsOnPageChange}
				labelRowsPerPage={window.Alfresco.messages.global['edocat.pagination.rowsPerPage']}
      />
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators({ onPageChange, onRowsOnPageChange }, dispatch),
});

export default connect(null, mapDispatchToProps)(EdocatTablePagination);
